import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { Box } from "@mui/system";
import { apiClient } from "app/configs/apiClient";
import { selectUser } from "app/store/userSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SuccessPopUp from "./SuccessPopUp";

const Youtube = () => {
    const navigate = useNavigate();

    const { institutionGatewayDetailId } = useSelector(
        (state) => state.fuse.selectLocation
    );

    const [channels, setChannels] = useState([]);
    const [setsuc, setSetsuc] = useState("");

    const user = useSelector(selectUser);

    const institutonMasterId = user?.data?.institutionMasterId;

    const params = new URLSearchParams(window.location.search);

    const youtubeCode = params.get("code");

    const platformId = 5;

    const [selectedPageName, setSelectedPageName] = useState()

    const [successMessage, setSuccessMessage] = useState('');
    const [successSubText, setSuccessSubText] = useState('');

    const handlePageSelect = async (event) => {
        try {
            const token = localStorage.getItem("jwt_access_token");
            const response = await apiClient().post(
                `/youtube/select-channel?platform_id=${platformId}&gateway_details_id=${institutionGatewayDetailId}`,
                event
            );
            // toast.success(response?.data?.message);
            // setSetsuc(response?.data?.message);
            // console.log("response", response);
            // setSuccessMessage(response?.data?.success)
            if (response?.data?.success === true) {
                setSuccessMessage(true)
                navigate("/integration");
            }
        } catch (error) {
            console.error("Error fetching Instagram business account:", error);
        }

    };

    useEffect(() => {
        const youtubeAccess = async () => {
            if (
                !institutionGatewayDetailId ||
                !youtubeCode ||
                !institutonMasterId
            ) {
                console.warn("Missing required parameters for Instagram access.");
                return;
            }

            const url = `/youtube/channel?code=${youtubeCode}&gateway_details_id=${institutionGatewayDetailId}&platform_id=${platformId}`;

            try {
                const response = await apiClient().get(url);
                const accessCode = response?.data?.code;
                // console.log("response", response?.data?.response?.items);
                setChannels(response?.data?.response?.items)

                if (accessCode) {
                    await getAccessToken(accessCode);
                } else {
                    console.warn("No accessCode returned from Instagram callback.");
                }
            } catch (error) {
                console.error("Error fetching Instagram data:", error);
            }
        };

        youtubeAccess();
    }, [institutionGatewayDetailId, youtubeCode, institutonMasterId]);

    return (
        <>
            {
                successMessage &&
                <SuccessPopUp
                    message={"integration completed successfully"}
                    open={true}
                    subText="okkkkkk"
                />
            }

            <Grid
                container
                sx={{
                    bgcolor: "",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        width: 500,
                        bgcolor: "",
                        borderRadius: 5,
                        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        mb: 5,
                        pb: 5,
                    }}
                >
                    <Grid container sx={{ justifyContent: "center" }}>
                        <Box
                            component="img"
                            src="/assets/images/logo/logo-image.png"
                            sx={{ width: "45%" }}
                        />
                    </Grid>

                    <Grid container sx={{ justifyContent: "center", mb: 5 }}>
                        {
                            channels?.length > 0 && (
                                <FormControl
                                    sx={{
                                        minWidth: 300,
                                    }}
                                >
                                    <InputLabel id="demo-simple-select-label" sx={{ background: '#fff' }}>
                                        {/* {getDropDownLabel()} */}Select YouTube Channel
                                    </InputLabel>

                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={selectedPageName}
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                                        onChange={(e) => {
                                            // setSelectedPageName(e.target.value)
                                            handlePageSelect(e.target.value)
                                        }}
                                    >
                                        {
                                            channels?.map((data) => (
                                                <MenuItem
                                                    onClick={() => {
                                                        setSelectedPageName(data);
                                                        // onPageSelected(data?.name);
                                                    }}
                                                    value={data}
                                                >
                                                    {data?.snippet?.title}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>

                                </FormControl>
                            )
                        }
                    </Grid>
                </Box>
            </Grid>
        </>
    )
}
export default Youtube;